import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Vehicle Locations API calls
 */
const vehicleLocationService = {
  /**
   * Get all vehicle locations with pagination and filters
   */
  getAllLocations: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        search = '',
        status = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_LOCATIONS.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleLocationService.getAllLocations'));
    }
  },

  /**
   * Get a single vehicle location by ID
   */
  getLocationById: async (id) => {
    try {
      return await apiClient.get(API_ENDPOINTS.VEHICLE_LOCATIONS.GET_BY_ID(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleLocationService.getLocationById'));
    }
  },

  /**
   * Create a new vehicle location
   * Accepts JSON or FormData (file field: image)
   */
  createLocation: async (locationData) => {
    try {
      return await apiClient.post(API_ENDPOINTS.VEHICLE_LOCATIONS.CREATE, locationData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleLocationService.createLocation'));
    }
  },

  /**
   * Update a vehicle location
   * Accepts JSON or FormData (file field: image)
   */
  updateLocation: async (id, locationData) => {
    try {
      return await apiClient.put(API_ENDPOINTS.VEHICLE_LOCATIONS.UPDATE(id), locationData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleLocationService.updateLocation'));
    }
  },

  /**
   * Delete a vehicle location
   */
  deleteLocation: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_LOCATIONS.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleLocationService.deleteLocation'));
    }
  },

  /**
   * Delete multiple vehicle locations
   */
  deleteMultipleLocations: async (ids) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_LOCATIONS.DELETE_MULTIPLE, { data: { ids } });
    } catch (error) {
      throw new Error(handleError(error, 'vehicleLocationService.deleteMultipleLocations'));
    }
  },

  /**
   * Toggle location status
   */
  toggleLocationStatus: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.VEHICLE_LOCATIONS.TOGGLE_STATUS(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleLocationService.toggleLocationStatus'));
    }
  },
};

export default vehicleLocationService;
